export const defaultPreferences = {
    renderingStrategy: {
        pdp: {
            offset: {
                mobile: 300,
                desktop: 500,
                tablet: 400,
            },
            height: {
                mobile: 300,
                desktop: 500,
                tablet: 400,
            },
        },
    },
};
